import React from 'react';
import PropTypes from 'prop-types';
import './IframeContainer.less';


const IframeContainer = (props) => {
  return (
    <iframe rel="preload" style={props.style} className="data-and-bi-iframe" src={props.src} title={props.title} />
  );
};

IframeContainer.propTypes = {
  title: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  style: PropTypes.object
};

export default IframeContainer;
